import type { TextStyleOptions } from 'pixi.js';

export const UI_COLORS = {
  paper: 0x191713,
  paperDark: 0x0f0f0f,
  paperLight: 0x242019,
  ink: 0xf6f1e8,
  mutedInk: 0xb9b3a7,
  red: 0xd34c3f,
  redDark: 0x7c1f1a,
  gold: 0xe1b84b,
  black: 0x080808,
  disabled: 0x4b4740
} as const;

export const UI_FONT_FAMILY = 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif';

export const UI_TEXT_STYLES = {
  button: {
    fill: UI_COLORS.ink,
    fontFamily: UI_FONT_FAMILY,
    fontSize: 22,
    fontWeight: '700'
  },
  panelTitle: {
    fill: UI_COLORS.gold,
    fontFamily: UI_FONT_FAMILY,
    fontSize: 22,
    fontWeight: '800'
  },
  modalBody: {
    fill: UI_COLORS.ink,
    fontFamily: UI_FONT_FAMILY,
    fontSize: 24,
    lineHeight: 36,
    wordWrap: true
  },
  textBoxSpeaker: {
    fill: UI_COLORS.black,
    fontFamily: UI_FONT_FAMILY,
    fontSize: 21,
    fontWeight: '800'
  },
  textBoxBody: {
    fill: UI_COLORS.ink,
    fontFamily: UI_FONT_FAMILY,
    fontSize: 29,
    lineHeight: 42,
    wordWrap: true,
    breakWords: true
  }
} satisfies Record<string, TextStyleOptions>;
